// extracted by mini-css-extract-plugin
module.exports = {"static-pages-header":"static-page_static-pages-header__2dMNS","static-pages-title":"static-page_static-pages-title__20a4r"};